<template>
  <dialog-base show-close @close="close">
    <div class="mod-rule">
      <div class="title">
        活动规则
      </div>
      <div class="scroller" @touchstart="isShowControl = false" @toumove.stop="">
        <div class="content"
             v-html="RuleText">
        </div>
      </div>
      <div v-if="isShowControl" class="btn-tip">
        上划查看更多<i class="triangle"></i>
      </div>
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from '../base'
import mixin from '../mixin'
import {
  RuleText
} from '@/constants'
export default {
  mixins: [mixin],
  components: {
    DialogBase
  },
  data() {
    return {
      RuleText,
      isShowControl: true
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.mod-rule {
  padding: 39px 54px 63px;
  position: relative;
  width: 644px;
  height: 640px;
  background: #fdf2e5;
  border: 4px solid #882104;
  border-radius: 30px;
  .btn-tip {
    position: absolute;
    left: 50%;
    bottom: 27px;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 240px;
    height: 62px;
    font-size: 28px;
    color: #882104;
    background: #ffffff;
    border: 4px solid #882104;
    border-radius: 31px;
    .triangle {
      margin-top: 10px;
      margin-left: 8px;
      transform: translateY(-50%);
      display: inline-block;
      font-size: 0;
      border: 10px solid;
      border-color: transparent transparent #882104 transparent;
    }
  }
  .title {
    font-size: 42px;
    font-weight: bold;
    color: #f57906;
    text-align: center;
  }
  .scroller {
    margin-top: 32px;
    width: 535px;
    height: 466px;
    font-size: 28px;
    font-weight: 400;
    color: #882104;
    overflow-y: scroll;
    .content {
      white-space: pre-line;
    }
  }
}
</style>